/* eslint-disable no-restricted-globals */
import { CDP_INITIATIVE, IS_SERVER } from "@/constants";
import { useConfig } from "@/contexts/cdpConfig";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
import { useEffect } from "react";
import { useTrackingViewBase } from "./useTrackingViewBase";
export const useErrorTrackingView = (statusCode) => {
    const { env, trackingSite } = useConfig();
    const { language } = useLocale();
    const path = IS_SERVER ? "" : window.location.pathname;
    const viewProps = {
        av_pagetitle: "classified_detail",
        av_category: "classified",
        av_environment: env,
        av_error_code: `${statusCode}`,
        av_url_path: path,
        av_language: language,
        av_site: trackingSite,
        av_platform: "web",
        av_initiative: CDP_INITIATIVE,
    };
    // view object is subject to change so it's not listed as dep (to avoid sending the event twice)
    const view = useTrackingViewBase(viewProps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(view, []);
};
